import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './css/animate.css';
import './css/odometer.css';
import './css/meanmenu.css';
import './css/main.css';





import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
